export default __webpack_public_path__ + "static/media/kafteji.6b5328d6.png";